import React, { useState, useEffect, useContext } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Home_context } from '../../context/home_context';

// let dummy_data=[
//     {
//         'Formulation':'Cosmetic Use: Granlipid RSC can be used in any emulsion of oil-containing products. Its suggested use level is from 1-5% and it should be added to the oil phase. Temperatures in excess of 80°C should be avoided for any length of time.',
//         'Incompatibilities':'Formula dependent.',
//         '% utilization':'1 - 5 %',
//         'Solubility':'Insoluble',
//     },
//         {
//         'Formulation':'Oil phase',
//         'Incompatibilities':'',
//         '%utilization':'',
//         'Solubility':'',
//     }

// ]
export default function Conditions_to_use() {
  const { report_data_state } = useContext(Home_context);

  return (
    <div>
      <p className="page_headers  font-semibold text-start pt-2 header_color">
        BEST USE
      </p>
      <div className=" report_id_tables card">
        <DataTable
          value={report_data_state?.report_data['conditions_to_use_dummy_data']}
          showGridlines
          className="page_table_font_size"
        >
          <Column field="Formulation" header="Formulation"></Column>
          <Column field="Incompatibilities" header="Incompatibilities"></Column>
          {/* <Column field="% utilization" header="% utilization"></Column> */}
          <Column field="Solubility" header="Solubility"></Column>
        </DataTable>
      </div>
    </div>
  );
}
